import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalizationConfigService {

  constructor() { }
  public locale_id: string = '';
}
